
import { DogSchool } from "@/data/dogSchools";
import { parseCoordinatesFromAddress } from "./locationUtils";
import { formatWorkingHours } from "./formatUtils";
import { extractFeatures } from "./featureUtils";
import { determineStateFromPostalCode } from "./locationUtils";
import { getRandomPlaceholderImage } from "./formatUtils";

/**
 * Function to convert Supabase row to DogSchool object
 */
export const mapSupabaseRowToDogSchool = (row: any): DogSchool => {
  console.log("Mapping row to DogSchool:", row);
  
  // Format the address properly to avoid duplication
  const address = row.street || "";
  
  // Get coordinates directly from the database fields
  const latitude = row.latitude ? parseFloat(String(row.latitude)) : undefined;
  const longitude = row.longitude ? parseFloat(String(row.longitude)) : undefined;
  
  // Extract reviews from row (review1 to review10)
  const reviews: string[] = [];
  for (let i = 1; i <= 10; i++) {
    const reviewField = `review${i}`;
    if (row[reviewField] && typeof row[reviewField] === 'string') {
      reviews.push(row[reviewField]);
    }
  }
  
  // Parse review count with fallback to 0
  const reviewCount = parseInt(row.reviewscount || row.reviews_count || "0", 10) || 0;
  
  // Preserve distance if it was already calculated
  const distance = typeof row.distance === 'number' ? row.distance : undefined;
  
  // Create the DogSchool object with default values for every property
  const dogSchool: DogSchool = {
    id: row.google_id || String(Math.random()),
    name: row.name || "Unnamed Dog School",
    street: address,
    city: row.city || "",
    state: determineStateFromPostalCode(row.postal_code, row.country || "Germany") || row.state || "",
    country: row.country || "Germany",
    postalCode: row.postal_code || "",
    openingHours: formatWorkingHours(row.working_hours),
    phone: row.phone || "",
    email: row.email || "",
    website: row.site || "",
    description: row.about || "",
    latitude: latitude,
    longitude: longitude,
    googleReview: parseFloat(String(row.reviewsrating || row.reviews)) || 4.5,
    reviewCount: reviewCount,
    imageUrl: row.photo || getRandomPlaceholderImage(),
    features: extractFeatures(row.about),
    reviews: reviews,
    googleMapsUrl: row.google_maps_url || "",
    
    // Add alias properties to match the code that uses them
    phoneNumber: row.phone || "",
    address: address,
    location: latitude && longitude ? { lat: latitude, lng: longitude } : undefined,
    distance: distance
  };
  
  console.log("Mapped DogSchool object:", {
    id: dogSchool.id,
    name: dogSchool.name,
    postalCode: dogSchool.postalCode,
    city: dogSchool.city,
    coordinates: [dogSchool.latitude, dogSchool.longitude],
    rating: dogSchool.googleReview,
    reviews: dogSchool.reviewCount,
    distance: dogSchool.distance
  });
  
  return dogSchool;
};
